
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"59","height":"59","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('rect',{attrs:{"width":"59","height":"59","rx":"29.5","fill":"#E6EBFF"}}),_c('g',{attrs:{"clip-path":"url(#clip0_6162_103638)"}},[_c('g',{attrs:{"clip-path":"url(#clip1_6162_103638)"}},[_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M30.334 31.333H41v-2.667H30.334V18h-2.667v10.667H17v2.667h10.667v10.666h2.666V31.333z","fill":"#0037FF"}})])]),_c('defs',[_c('clipPath',{attrs:{"id":"clip0_6162_103638"}},[_c('path',{attrs:{"fill":"#fff","transform":"translate(13 14)","d":"M0 0h32v32H0z"}})]),_c('clipPath',{attrs:{"id":"clip1_6162_103638"}},[_c('path',{attrs:{"fill":"#fff","transform":"translate(13 14)","d":"M0 0h32v32H0z"}})])])])
          )
        }
      }
    